import React from 'react';
import ArchivePanel from '../components/story/ArchivePanel';

const ArchivePage = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <div className="mb-8">
        <h1 className="text-3xl font-serif font-bold text-gray-900 dark:text-white">Full Story Archive</h1>
        <p className="text-sm text-gray-800 dark:text-purple-400 mt-2">Export, import, or permanently delete your entire story structure. For individual chapter review, use the Chapters tab in the Narrative view.</p>
      </div>
      <div className="bg-white dark:bg-purple-900/20 p-8 rounded-3xl border border-gray-100 dark:border-purple-800 shadow-xl">
        <ArchivePanel isSidebar={false} />
      </div>
    </div>
  );
};

export default ArchivePage;
